export default "__VITE_ASSET__CPtgbg5V__"